export enum PricePerTourists {
  Total,
  PerTourist
}
